
import React from "react";
import { useCookies } from "react-cookie"
import { ApiHelper, UserContextInterface } from "./helpers";

interface Props { context?: UserContextInterface, }

export const Logout: React.FC<Props> = (props) => {
  const [, , removeCookie] = useCookies(["jwt", "email", "name"]);

  removeCookie("jwt");
  removeCookie("email");
  removeCookie("name");

  ApiHelper.clearPermissions();
  props.context?.setUserName("");
  setTimeout(() => {
    // a must check for Nextjs
    if (typeof window !== "undefined") {
      window.location.href = "/";
    }
  }, 300);
  return null;
}